<template>
  <v-row v-if="organizationSearchPosts" justify="center">
    <v-col cols="12" style="max-width:344px">
      <div class="text-center">
        <span
          class="title text--primary"
          v-text="organizationSearchPosts.count + ' partages'"
        >
        </span>
      </div>
      <BaseExperienceCard
        :post="post.post"
        v-for="post in this.organizationSearchPosts.organizationPosts"
        :key="post.post.id"
        class="ma-1"
      ></BaseExperienceCard>
      <BasePagination
        v-if="organizationSearchPosts.count"
        :value="page"
        :circle="true"
        :length="organizationSearchPosts.numPages"
        :total-visible="5"
        @input="changePage($event)"
      ></BasePagination>
    </v-col>
  </v-row>
</template>

<script>
import OrganizationService from "../services/OrganizationService";
export default {
  name: "TheOrganizationHome",
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      organizationSearchPosts: {},
      page: 1
    };
  },
  methods: {
    getOrganizationPosts(page) {
      this.posts = [];
      OrganizationService.getOrganizationPosts(parseInt(this.id), page).then(
        res => (this.organizationSearchPosts = res)
      );
    },
    changePage(value) {
      this.page = value;
    }
  },
  computed: {
    organizationId() {
      return this.id;
    }
  },
  watch: {
    organizationId(newValue, oldValue) {
      if (newValue != oldValue) {
        this.getOrganizationPosts(this.page);
      }
    },
    page() {
      this.getOrganizationPosts(this.page);
    }
  },
  created() {
    this.getOrganizationPosts(this.page);
  }
};
</script>
